module.exports = __webpack_public_path__ + "static/media/calculator.6b964d9b.svg";